/*
 * Arcana add-to-cart age confirmation.
 *
 * Intercepts the first add-to-cart of a session and asks the buyer to confirm
 * they are of legal age before the item is added. A single capture-phase
 * `submit` handler is the only interception path (it runs before Dawn's own
 * product-form handler and before any AJAX add), so the modal fires exactly
 * once per add. Guarded against duplicate init on section re-render.
 */
(function () {
  'use strict';

  if (window.__arcanaCartAgeInit) return;
  window.__arcanaCartAgeInit = true;

  var confirmed = document.cookie.indexOf('arcana_cart_age=1') !== -1;
  var pendingForm = null;
  var lastFocus = null;

  function isCartAddForm(form) {
    return form && form.action && form.action.indexOf('/cart/add') !== -1;
  }

  function modalEl() {
    return document.getElementById('arcana-cart-age-modal');
  }

  function focusable(modal) {
    return Array.prototype.filter.call(
      modal.querySelectorAll('button:not([disabled]), a[href], [tabindex]:not([tabindex="-1"])'),
      function (el) { return el.offsetParent !== null; }
    );
  }

  function onKeydown(e) {
    var modal = modalEl();
    if (!modal || !modal.classList.contains('is-open')) return;
    if (e.key === 'Escape') {
      e.preventDefault();
      hide();
      return;
    }
    if (e.key !== 'Tab') return;
    var items = focusable(modal);
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  function show(form) {
    var modal = modalEl();
    if (!modal) return;
    pendingForm = form;
    lastFocus = document.activeElement;
    modal.classList.add('is-open');
    document.body.classList.add('age-gate-active');
    var confirmBtn = document.getElementById('cart-age-confirm');
    (confirmBtn || modal.querySelector('.cart-age__modal')).focus();
  }

  function hide() {
    var modal = modalEl();
    if (modal) modal.classList.remove('is-open');
    document.body.classList.remove('age-gate-active');
    pendingForm = null;
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
  }

  // Single interception path: capture-phase submit, before Dawn / AJAX handlers.
  document.addEventListener(
    'submit',
    function (e) {
      if (confirmed) return;
      if (!isCartAddForm(e.target)) return;
      e.preventDefault();
      e.stopPropagation();
      show(e.target);
    },
    true
  );

  document.addEventListener('keydown', onKeydown, true);

  document.addEventListener('click', function (e) {
    var modal = modalEl();
    if (!modal) return;

    if (e.target.closest('#cart-age-confirm')) {
      confirmed = true;
      document.cookie = 'arcana_cart_age=1; path=/; SameSite=Lax' +
        (window.location.protocol === 'https:' ? '; Secure' : '');
      var form = pendingForm;
      hide();
      if (form) {
        if (form.requestSubmit) form.requestSubmit();
        else form.submit();
      }
    } else if (e.target.closest('#cart-age-cancel') || e.target.closest('.cart-age__overlay')) {
      hide();
    }
  });
})();
